import type { VoidFunctionComponent } from 'react';

import { icons, IconText, TooltipBadge } from '../../../generic';

type SnippetsBadgeProps = {
  issueId: number;
};

/**
 * Visual indicator for when an issue is derived from a snippet.
 */
const SnippetsBadge: VoidFunctionComponent<SnippetsBadgeProps> = ({ issueId }) => (
  <TooltipBadge
    id={`snippets-issue-badge-tooltip-${issueId}`}
    tooltip="This issue was discovered from a code snippet"
    color="white"
    placement="right"
    showTooltip
  >
    <IconText
      icon={icons.receipt}
      text="Snippet"
    />
  </TooltipBadge>
);

export default SnippetsBadge;
